import { Link } from "react-router-dom"
import Carousel from "./carousel"
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

const Header =()=>{
    const { t } = useTranslation();
    function changeLang(e) {
       
        localStorage.setItem("lang", e);
        i18n.changeLanguage(localStorage.getItem("lang"));
      }

      // State to manage whether the header is open or not
  const [isHeaderOpen, setIsHeaderOpen] = useState(false);

  // Function to toggle the header
  const toggleHeader = () => {
    setIsHeaderOpen(!isHeaderOpen);

    window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional: smooth scrolling animation
      });
  };

  // useEffect hook to add/remove the class to the body element
//   useEffect(() => {
//     // Add or remove the class based on the state
//     if (isHeaderOpen) {
//       document.body.classList.add('header--is-open');
//     } else {
//       document.body.classList.remove('header--is-open');
//     }

//     // Clean up function to remove the class when component unmounts
//     return () => {
//       document.body.classList.remove('header--is-open');
//     };
//   }, [isHeaderOpen]); // This effect depends on the value of isHeaderOpen

useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia('(max-width: 1023px)').matches) {
        if (isHeaderOpen) {
          document.body.classList.add('header--is-open');
        } else {
          document.body.classList.remove('header--is-open');
        }
      } else {
        // Ensure the class is removed if the screen is larger than 1030px
        document.body.classList.remove('header--is-open');
      }
    };

    // Initial check
    handleResize();

    // Listen for resize events
    window.addEventListener('resize', handleResize);

    // Clean up function to remove the class when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('header--is-open');
    };
  }, [isHeaderOpen]); // This effect depends on the value of isHeaderOpen

  const [scrollClass, setScrollClass] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > 0) {
        setScrollClass('header--on-scroll');
      } else {
        setScrollClass('');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



      useEffect(()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: smooth scrolling animation
          });
      },[])

      const [openedItem, setOpenedItem] = useState(null);

      const toggleItem = (itemId) => {
        setOpenedItem(itemId === openedItem ? null : itemId);
      };

      
    return(
        <>
        <Helmet>
                <link rel="stylesheet" href="/css/style.css"/>
                <link rel="stylesheet" href="/css/style2.css"/>
            </Helmet>
         <header id="pageHeader" className={`header ${scrollClass}`}>
<input id="searchUrl" name="searchUrl" type="hidden" value="/search-page/" />
    <div className="header__wrapper grid">
      <div className="grid__item lg--four-twelfths">
        <a className="brand header__logo" href="/">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1579 166.46156"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M1209.44644,80.63261a7.68786,7.68786,0,0,0,1.56005,1.30335c19.54056,7.81256,25.16258,27.6243,22.15431,45.14359-2.20575,12.84522-9.836,21.80838-21.748,25.76555-9.78064,3.24922-20.32236,5.63366-30.56946,5.80133-40.28936.65924-80.59546.2925-120.89547.29293-.93818,0-1.87637-.1621-3.21858-.28587V7.90173a46.33015,46.33015,0,0,1,5.495-.60544q57.54391-.0553,115.08782-.0027c10.363.01469,20.35783,1.678,29.83378,6.33877,24.55179,12.0758,28.067,50.2417,5.35168,64.39568A26.9423,26.9423,0,0,0,1209.44644,80.63261Zm-127.63036,55.16013c1.69827.13872,2.65221.28464,3.60614.2847,31.152.00184,62.30417.04741,93.45561-.08579a66.15763,66.15763,0,0,0,13.22416-1.47778c10.94844-2.30049,16.29217-8.93485,16.16317-19.458-.1395-11.38184-5.61862-18.20784-16.7453-20.35391a62.05658,62.05658,0,0,0-11.5317-1.00523q-46.14731-.12127-92.29519-.038c-1.8697.00106-3.7394.20991-5.87689.33814Zm.04285-65.53641a16.149,16.149,0,0,0,2.36158.46c31.94743.0101,63.89884.2499,95.83861-.24954,5.23162-.0818,10.936-2.59456,15.4922-5.46125,6.65089-4.18444,8.564-11.20088,7.233-18.90069a17.02652,17.02652,0,0,0-12.33322-14.083,43.27537,43.27537,0,0,0-12.53418-1.7936c-30.01117-.14641-60.02334-.08422-90.03522-.06888-1.88773.001-3.7756.16567-6.02279.271Z" /><path d="M265.13419,7.29406c9.97172,0,19.25162-.21243,28.50566.18218,1.8151.0774,3.89781,2.21,5.23633,3.8895q32.77555,41.12348,65.37708,82.38561c1.19736,1.51061,2.443,2.98287,4.11118,5.015,1.50006-1.76637,2.85667-3.27666,4.11835-4.86251,20.74128-26.0714,41.72282-51.95846,62.02148-78.3703,4.94956-6.44018,9.982-9.20159,17.90611-8.39694,6.29614.63935,12.70908.12883,19.489.12883V158.47619H447.39471V36.60027l-1.439-.63642c-25.766,32.42038-51.53206,64.84076-77.73617,97.81233-25.931-32.89728-51.53273-65.3768-78.0824-99.05891V158.4755h-25.003Z" /><path d="M676.20845,39.51966c-6.88725,3.455-13.70581,7.06354-20.73255,10.2066-1.10891.496-3.58529-.68542-4.71137-1.81019-27.5333-27.50182-69.42557-26.53483-94.68564-14.56261-21.1458,10.02224-34.07435,26.12582-33.67416,50.428.39757,24.13765,13.12616,40.52356,34.83125,49.61028,22.3224,9.34514,45.298,9.63922,68.01545,1.11251,15.72714-5.903,28.64945-19.55968,31.93189-33.01606-2.13792-.11515-4.15854-.31592-6.17938-.31849-19.17414-.02448-38.34934-.12327-57.52156.06874-4.19708.042-5.99022-.98567-5.71107-5.48111.34442-5.54656.08231-11.13078.08231-17.027h101.46c.43681,14.98663-2.49121,28.7548-9.66945,41.51442-11.28293,20.05586-28.8438,32.15289-50.5845,38.0829-30.964,8.44575-61.48391,7.14878-90.42825-7.681-37.20918-19.06432-52.53315-60.95232-36.30164-97.59987A71.578,71.578,0,0,1,532.94389,19.025C571.0827-2.43784,610.323-4.12234,649.35519,16.356,659.416,21.63443,667.767,30.17179,676.90354,37.21206Q676.556,38.36586,676.20845,39.51966Z" /><path d="M1427.18072,158.928c-8.547,0-16.603.16914-24.63807-.16442-1.3591-.05643-3.06219-2.04337-3.86727-3.53679-4.59173-8.5178-9.09023-17.09246-13.33527-25.787-1.55778-3.19068-3.44891-4.45782-7.09564-4.44085q-46.19288.21484-92.38715.015c-3.34191-.01229-5.22452.9951-6.72412,4.0642q-6.49954,13.30233-13.67331,26.26749a7.3936,7.3936,0,0,1-5.04926,3.44666c-7.52223.38091-15.0747.16157-23.33162.16157a44.5775,44.5775,0,0,1,1.74184-4.49848q37.6368-71.41748,75.251-142.8468c1.66151-3.16553,3.478-4.55408,7.12729-4.42272,7.54395.27155,15.113-.11266,22.652.22056,1.88787.08345,4.59628,1.38914,5.4181,2.9353q38.705,72.82289,77.04991,145.83717A19.56267,19.56267,0,0,1,1427.18072,158.928Zm-56.7751-57.15955c-12.78039-24.38042-25.20373-48.07956-38.16847-72.81178-12.994,24.667-25.50856,48.42392-38.35551,72.81178Z" /><path d="M183.65749,41.91159c-7.4723,2.67907-13.944,5.15888-20.54575,7.22235-1.21754.38055-3.29635-.53743-4.41383-1.50633C129.151,22.00948,95.59049,19.47029,60.79422,32.95856c-30.28,11.7376-42.67794,43.31515-30.3543,71.66512,6.50656,14.96805,18.29591,24.41454,33.28376,29.69022,23.067,8.11951,46.59735,8.47087,69.41437-.22232,9.13055-3.47871,17.027-10.36924,25.17693-16.14189,2.38055-1.68614,3.824-2.49087,6.502-.87035,5.605,3.39172,11.41924,6.4376,17.74046,9.95546-9.26546,11.22847-19.6395,20.2936-32.46454,25.57377-35.97977,14.8131-72.30287,15.27537-107.44442-2.0105C17.15972,138.06039,1.8731,117.19691.15959,87.90518c-1.80942-30.93139,11.83394-53.68382,37.543-69.79611A99.04626,99.04626,0,0,1,78.538,3.91153c33.61934-4.1745,64.86063,1.323,91.6428,23.69014a122.46767,122.46767,0,0,1,9.10205,8.95214C180.6131,37.92472,181.7173,39.51492,183.65749,41.91159Z" /><path d="M854.57375,158.6181H713.73249V7.69214h24.6932V135.88772H854.57375Z" /><path d="M1438.1039,7.68138h24.44152V136.12954H1579v22.38935H1438.1039Z" /><path d="M232.19287,158.62362H207.79221V7.83794h24.40066Z" /><path d="M1033.286,83.231a83.16236,83.16236,0,0,0-69.87258-82.203C955.19387,5.54911,946.76769,12.536,938.54629,21.5787a12.46852,12.46852,0,0,1,5.54908,10.27538,12.18741,12.18741,0,0,1-1.02784,4.72631,255.664,255.664,0,0,1,28.77034,28.97694,287.5749,287.5749,0,0,1,22.4,30.41476,15.91324,15.91324,0,0,1,3.082-.41142,12.38841,12.38841,0,0,1,11.91944,9.0427A107.5919,107.5919,0,0,0,1032.462,94.53313a67.92116,67.92116,0,0,0,.82284-11.30182Z" /><path d="M1031.642,99.8771a99.77148,99.77148,0,0,1-21.99005,9.0427,11.75411,11.75411,0,0,1-4.10979,8.01479c1.43925,3.082,2.672,6.37037,3.905,9.24748a99.47322,99.47322,0,0,1,3.49345,11.30328,81.36372,81.36372,0,0,0,18.70156-37.60789Z" /><path d="M870.113,106.04233a81.04243,81.04243,0,0,0,15.82446,30.00484,100.30973,100.30973,0,0,1,1.02783-15.41307,12.04112,12.04112,0,0,1-6.37037-10.68676,62.06064,62.06064,0,0,1-10.48162-3.905Z" /><path d="M990.54045,97.61652A251.76912,251.76912,0,0,0,968.757,68.22967,241.47338,241.47338,0,0,0,940.80651,40.074a12.4537,12.4537,0,0,1-9.0427,4.10978,11.30757,11.30757,0,0,1-8.42618-3.49344,217.6503,217.6503,0,0,0-18.70156,33.49811,207.65959,207.65959,0,0,0-8.63132,23.63264,12.38906,12.38906,0,0,1,9.04271,11.91945v1.43925a245.63326,245.63326,0,0,0,45.41718,2.672,233.45208,233.45208,0,0,0,35.14253-3.69841,4.06768,4.06768,0,0,1-.41141-2.26208A12.289,12.289,0,0,1,990.53969,97.616Z" /><path d="M950.05545,166.46156a83.34539,83.34539,0,0,0,59.59721-25.07193,87.21723,87.21723,0,0,0-3.905-13.56387c-1.02784-2.877-2.26065-5.54907-3.49345-8.42618a17.48179,17.48179,0,0,1-4.7263.82284,12.25632,12.25632,0,0,1-10.48052-5.75421,250.06174,250.06174,0,0,1-36.58035,3.6984c-3.082.205-6.1656.205-9.24748.205a234.41465,234.41465,0,0,1-37.40238-2.877,12.19689,12.19689,0,0,1-11.09668,6.78175,5.70126,5.70126,0,0,1-1.84924-.205,99.55665,99.55665,0,0,0-.61641,18.90669,82.53448,82.53448,0,0,0,59.80272,25.48332Z" /><path d="M957.04271.41142C954.78206.20643,952.31641,0,950.05582,0a81.47032,81.47032,0,0,0-44.38964,12.94735,103.82017,103.82017,0,0,1,18.29018,9.45408,12.36218,12.36218,0,0,1,7.80966-2.672,13.81512,13.81512,0,0,1,2.877.41142A107.09235,107.09235,0,0,1,957.043.41135Z" /><path d="M900.93914,72.7501a207.98579,207.98579,0,0,1,19.93424-35.34731,10.17772,10.17772,0,0,1-1.43926-5.54908,11.5372,11.5372,0,0,1,1.84924-6.37037,92.70572,92.70572,0,0,0-19.72946-9.864A83.55144,83.55144,0,0,0,868.67345,100.905a85.67151,85.67151,0,0,0,12.33119,4.93255A12.49769,12.49769,0,0,1,891.69141,97.618a194.59578,194.59578,0,0,1,9.24747-24.86715Z" /></g></g></svg>
        </a>
      </div>

      <div className="grid__item lg--eight-twelfths">
        {/* <button className="btn btn-icon header__btn-nav" type="button">
            <span className="icon icon-burger header__btn-open"></span>
            <span className="icon icon-close header__btn-close"></span>
            <span className="u-visually-hidden">Menu</span>
        </button> */}
         <button className="btn btn-icon header__btn-nav" type="button" onClick={toggleHeader}>
        {isHeaderOpen ?  <span className="icon icon-close header__btn-close"></span> : <span className="icon icon-burger header__btn-open"></span> }
        <span className="u-visually-hidden">Menu</span>
      </button>

        <div className="header__search">
            {/* <div className="search-bar">
                <input className="input--clear search-bar__input" type="text" id="headerSearchTerm" placeholder="Search CIMGlobal" name=""/>
                <button className="btn btn-icon search-bar__btn" id="headerSearchButton">
                    <span className="icon icon-search"></span>
                    <span className="u-visually-hidden">Search CIMGlobal</span>
                </button>
            </div> */}
        </div>

        <nav className="nav">
            <ul className="nav__list">
            <li className={`nav__item accordion ${openedItem === '1' ? 'nav__item--opened accordion--is-open' : ''}`}  onClick={() => toggleItem('1')}>
   <a className="nav__link" id="gm__4025" href="#" title="">Manage</a>
   <button className="btn nav__btn accordion__btn" type="button" onClick={() => toggleItem('1')}>
   <span className="icon icon-chevron"></span>
   <span className="u-visually-hidden">Expand</span>
   </button>
   <div class="dropdown dropdown--active" id="nav-dropdown">
      <div class="dropdown__wrapper">
         <div className="subnav accordion__content">
            <div className="grid">
               <div className="subnav__list lg--nine-twelfths push--lg--three-twelfths">
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/globalPresence">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Conference Management (PCO)</span>
                        </div>
                        <p className="subnav__text text--small text--dark">Comprehensive conference planning and execution services ensuring seamless
                           experiences and successful events worldwide.
                        </p>
                        </a>
                     </div>
                  </div>
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/associationManagement">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Association Consulting </span>
                        </div>
                        <p className="subnav__text text--small text--dark">Tailored association management solutions optimizing membership engagement, organizational growth, and mission achievement for long-term success.</p>
                        </a>
                     </div>
                  </div>
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/exhibitionManagement">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Exhibition Management</span>
                        </div>
                        <p className="subnav__text text--small text--dark">Expert exhibition management services delivering memorable and impactful
                           experiences that showcase your organization&#39;s vision.
                        </p>
                        </a>
                     </div>
                  </div>
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/bidding">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Bidding</span>
                        </div>
                        <p className="subnav__text text--small text--dark">Strategic bidding assistance to secure international conferences, elevating your
                           organization&#39;s profile and global presence.
                        </p>
                        </a>
                     </div>
                  </div>
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/outreach">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Outreach</span>
                        </div>
                        <p className="subnav__text text--small text--dark">Proactive outreach services in Asia and the Middle East, expanding your
                           organization&#39;s reach and impact globally.
                        </p>
                        </a>
                     </div>
                  </div>
                  <div className="grid__item md--one-half lg--one-third">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/communication">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Communication</span>
                        </div>
                        <p className="subnav__text text--small text--dark">Effective communication strategies to enhance engagement, foster connections, and
                           amplify your organization&#39;s message locally and globally.
                        </p>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</li>
<li className={`nav__item accordion ${openedItem === '2' ? 'nav__item--opened accordion--is-open' : ''}`}   onClick={() => toggleItem('2')}>
   <a className="nav__link" id="gm__4020" href="#" title="">Co-Create</a> 
   <button className="btn nav__btn accordion__btn" type="button" onClick={() => toggleItem('2')}>
   <span className="icon icon-chevron"></span>
   <span className="u-visually-hidden">Expand</span>
   </button>
   <div class="dropdown dropdown--active" id="nav-dropdown">
      <div class="dropdown__wrapper">
         <div className="subnav accordion__content">
            <div className="grid">
               <div className="subnav__list lg--nine-twelfths push--lg--three-twelfths">
                  <div className="grid__item md--one-half ">
                     <div className="subnav__item">
                        <a className="link dot__wrapper" onClick={toggleHeader} href="/Cocreate">
                        <div className="subnav__link">
                           <span className="dot"></span>
                           <span className="link__text">Co-Create: Elevate Your Association's Success with Tailored Events.
                           </span>
                        </div>
                        <p className="subnav__text text--small text--dark">Unlock your association's potential with Co-Create by CIMGLOBAL. Tailored events designed to amplify your goals – from boosting membership to igniting community engagement. Let's collaborate and bring your vision to life.</p>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</li>

                            <li className={`nav__item accordion ${openedItem === '3' ? 'nav__item--opened accordion--is-open' : ''}`}   onClick={() => toggleItem('3')}>
                                    <a className="nav__link" id="gm__4020" href="/ComingSoon" title="">Training</a>
{/*
                                    <button className="btn nav__btn accordion__btn" type="button" onClick={() => toggleItem('3')}>
                                        <span className="icon icon-chevron"></span>
                                        <span className="u-visually-hidden">Expand</span>
                                    </button>
                                    <div class="dropdown dropdown--active" id="nav-dropdown">
      <div class="dropdown__wrapper from-right">
      <div className="subnav accordion__content">
                                        <div className="grid">
                                            <div className="subnav__list lg--nine-twelfths push--lg--three-twelfths">

<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <Link className="link dot__wrapper" onClick={toggleHeader} href="/conference">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Conference</span>
            </div>
               
        </Link>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <Link className="link dot__wrapper" onClick={toggleHeader} to="/exhibition">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Exhibition</span>
            </div>
               
        </Link>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <Link className="link dot__wrapper" onClick={toggleHeader} to="/event">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Event</span>
            </div>
               
        </Link>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <Link className="link dot__wrapper" onClick={toggleHeader} to="/workshop">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Workshop</span>
            </div>
               
        </Link>
    </div>
</div>




                                           </div>
                                        </div>
                                    </div>
      </div>
   </div>
                                  
*/}
                            </li>

                              {/*    <li className={`nav__item accordion ${openedItem === '4' ? 'nav__item--opened accordion--is-open' : ''}`}   onClick={() => toggleItem('4')}>
                                    <a className="nav__link" id="gm__4049" href="/ComingSoon" title="">LIVE</a>

                              <button className="btn nav__btn accordion__btn" type="button" onClick={() => toggleItem('4')}>
                                        <span className="icon icon-chevron"></span>
                                        <span className="u-visually-hidden">Expand</span>
                                    </button>
                                    <div class="dropdown dropdown--active" id="nav-dropdown">
      <div class="dropdown__wrapper from-right">
      <div className="subnav accordion__content">
                                        <div className="grid">
                                            <div className="subnav__list lg--nine-twelfths push--lg--three-twelfths">

<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <Link className="link dot__wrapper" onClick={toggleHeader} to="/corporateEvents">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Corporate Events
</span>
            </div>
              
        </Link>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third" style={{height:0}}>
    <div className="subnav__item" style={{minHeight:0,visibility:"hidden"}}>
        <Link className="link dot__wrapper" onClick={toggleHeader} to="/corporateEvents">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Corporate Events
</span>
            </div>
                   </Link>
    </div>
</div>
                                            </div>
                                        </div>
                                    </div>
      </div>
   </div>
                                   

                            </li>*/}
                            
                            <li className={`nav__item accordion ${openedItem === '5' ? 'nav__item--opened accordion--is-open' : ''}`}   onClick={() => toggleItem('5')}>
                                    <a className="nav__link" id="gm__4038" href="#" title="">Company</a>

                                    <button className="btn nav__btn accordion__btn" type="button" onClick={() => toggleItem('5')}>
                                        <span className="icon icon-chevron"></span>
                                        <span className="u-visually-hidden">Expand</span>
                                    </button>
                                    <div class="dropdown dropdown--active" id="nav-dropdown">
      <div class="dropdown__wrapper from-right">
      <div className="subnav accordion__content">
                                        <div className="grid">
                                            <div className="subnav__list lg--nine-twelfths push--lg--three-twelfths">

<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/ourstory">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Our story</span>
            </div>
                <p className="subnav__text text--small text--dark">Our story begins in 1997 with a vision to go global</p>
        </a>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/whoweare">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Who we are</span>
            </div>
                <p className="subnav__text text--small text--dark">Our purpose, mission, and values</p>
        </a>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/CorporateGovernance">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Corporate governance and policies</span>
            </div>
                <p className="subnav__text text--small text--dark">Our corporate governance is implemented based on principles in accordance with CIMGLOBAL´s values</p>
        </a>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/Sustainability">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Sustainability</span>
            </div>
                <p className="subnav__text text--small text--dark">Learn how we integrate eco-conscious practices into every aspect of our operations</p>
        </a>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/Management">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Management </span>
            </div>
               <p className="subnav__text text--small text--dark">Diverse management team with experience spanning multiple industries and continents</p> 
        </a>
    </div>
</div>
<div className="grid__item md--one-half lg--one-third">
    <div className="subnav__item">
        <a className="link dot__wrapper" onClick={toggleHeader} href="/Career">
            <div className="subnav__link">
                <span className="dot"></span>
                <span className="link__text">Career</span>
            </div>
              <p className="subnav__text text--small text--dark">Join us in shaping the future – we're always seeking for motivated individuals to join our team.</p>
        </a>
    </div>
</div>
                                         </div>
                                        </div>
                                    </div>
      </div>
   </div>
                                    

                            </li>
                            <li className={`nav__item accordion ${openedItem === '6' ? 'nav__item--opened accordion--is-open' : ''}`}>
                                    <a className="nav__link" id="gm__4035" href="/Contact" title="">Contacts</a>                                   

                            </li>
            </ul>
           
            <ul className="nav__list nav__list--static">
               

              
                
                <li className="nav__item u-portable-hide">
                   {/* <button className="btn nav__link nav__link--search" type="button">
                        <span className="icon icon-search search__btn-open"></span>
                        <span className="icon icon-close search__btn-close"></span>
                            <span className="u-visually-hidden">Search CIMGlobal</span>
                    </button> */}
                </li>
                    <li className="nav__item">
                        
    {/* <div className="">
 
<Form.Select size="sm" onClick={(e) => changeLang(e.target.value)}>
<option selected="selected" value="en">English</option>
<option value="pr">Portguess</option>
      </Form.Select>
    </div> */}

                    </li>
            </ul>
            <div className="dropdown" id="nav-dropdown">
                <div className="dropdown__wrapper"></div>
            </div>
            <span className="dropdown__layer"></span>
        </nav>
      </div>
    </div>
</header>
       
        </>
    )
}
export default Header